import { render, staticRenderFns } from "./modalReclamacoes.vue?vue&type=template&id=349c4626&scoped=true"
import script from "./modalReclamacoes.vue?vue&type=script&lang=js"
export * from "./modalReclamacoes.vue?vue&type=script&lang=js"
import style0 from "./modalReclamacoes.vue?vue&type=style&index=0&id=349c4626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c4626",
  null
  
)

export default component.exports